import { action } from 'typesafe-actions'
import { OrderActionTypes } from './types'
import { IOrder } from '../interface'

// Search Request
export const listRequest = (searchParams:any) => action(OrderActionTypes.LIST_REQUEST, searchParams)
export const listSuccess = (data: IOrder[]) => action(OrderActionTypes.LIST_SUCCESS, data)
export const listError = (errors: any) => action(OrderActionTypes.LIST_ERROR, errors)
export const listClear = () => action(OrderActionTypes.LIST_CLEAR)

// Search Request
export const downloadRequest = (searchParams:any) => action(OrderActionTypes.DOWNLOAD_REQUEST, searchParams)
export const downloadSuccess = (url: string) => action(OrderActionTypes.DOWNLOAD_SUCCESS, url)
export const downloadError = (errors: any) => action(OrderActionTypes.DOWNLOAD_ERROR, errors)

// Select Data
export const selectData = (id: string) => action(OrderActionTypes.SELECT, id)
export const selectedData = () => action(OrderActionTypes.SELECTED)
export const selectedClear = () => action(OrderActionTypes.CLEAR_SELECTED)

// Create
export const createRequest = (doc: IOrder) => action(OrderActionTypes.CREATE_REQUEST, doc)
export const createSuccess = (doc: IOrder) => action(OrderActionTypes.CREATE_SUCCESS, doc) // Newly created data
export const createError = (errors: any) => action(OrderActionTypes.CREATE_ERROR, errors)

// // Read
// export const readRequest = (data: IOrder) => action(OrderActionTypes.READ_REQUEST, data)
// export const readSuccess = (data: IOrder) => action(OrderActionTypes.READ_SUCCESS, data)
// export const readError = (message: string) => action(OrderActionTypes.READ_ERROR, message)

// Update
export const updateRequest = (keyValues: any) => action(OrderActionTypes.UPDATE_REQUEST, keyValues)
export const updateSuccess = (doc: IOrder) => action(OrderActionTypes.UPDATE_SUCCESS, doc) // Updated Data
export const updateError = (errors: any) => action(OrderActionTypes.UPDATE_ERROR, errors)

// Delete
export const deleteRequest = (doc: IOrder) => action(OrderActionTypes.DELETE_REQUEST, doc)
export const deleteSuccess = (id: string) => action(OrderActionTypes.DELETE_SUCCESS, id)  // Return deleted organiser id to remove from state
export const deleteError = (errors: any) => action(OrderActionTypes.DELETE_ERROR, errors)
